// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"f8f6381e","977":"5f4ae0e1"}[chunkId] + ".chunk.js";
};